<template>
<div class="top-view">
<!--Header-->
<div id="header">
  <div class="container">
    <a class="brand" href="/"><img src="../assets/logo.png" alt=""></a>
  </div>
</div>

<!--Navbar-->
<div id="navbar">
  <div class="container">
    <div class="navbar-content">
      <ul id="primary-nav" class="nav">
        <li class="dropdown">
          <a href="#" @click.prevent="toggleDropdown" @blur="hideDropdown">
            <i class="icons-white-large nav-icon-subject"></i>
            <span class="menu-name" style="font-size:15px;">MENU</span>
          </a>
          <ul class="dropdown-menu" style="min-width:150px;" :style="{ display: showDropdown ? 'block' : 'none' }">
            <li><router-link to="/terms" @click="hideDropdown">&nbsp;&nbsp;&nbsp;&nbsp;利用規約</router-link></li>
            <li><a href="#" id="trial_request_logout" @click.prevent="handleLogout">&nbsp;&nbsp;&nbsp;&nbsp;ログアウト</a></li>
          </ul>
        </li>
      </ul>
      
    </div>
  </div>
</div>

<!--Container-->
<div class="container">
  <!-- Exam Selection Section -->
  <div class="exam-selection-section">
    <h3 class="section-title">試験を選択してください</h3>
    <div class="exam-list">
      <div 
        v-for="exam in visibleExamList" 
        :key="exam.examId"
        class="exam-item"
        :class="{ 'exam-item-active': selectedExamId === exam.examId }"
        @click="selectExam(exam.examId)"
      >
        <div class="exam-item-content">
          <span class="exam-name">{{ exam.name }}</span>
          <i v-if="selectedExamId === exam.examId" class="fa fa-check-circle check-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Content Table -->
  <form method="post" action="#" name="form">
    <table class="table table-bordered" style="margin-top:15px;">
      <tbody>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>コンテンツ名</strong></td>
          <td><strong>{{ selectedExam ? selectedExam.name : '' }}</strong></td>
        </tr>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>コンテンツ種別</strong></td>
          <td>テスト</td>
        </tr>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>実施状況</strong></td>
          <td>
            <span class="text-label" :class="isSelectedExamTaken ? 'label-success' : 'label-danger'">
              {{ isSelectedExamTaken ? '実施済' : '未実施' }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>実施可能回数</strong></td>
          <td>回数制限無し&nbsp;&nbsp;</td>
        </tr>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>制限時間</strong></td>
          <td>50 分</td>
        </tr>
        <tr>
          <td class="contents-info-tbl-colhead"><strong>中断</strong></td>
          <td>不可</td>
        </tr>
      </tbody>
    </table>

    <div class="info-field" style="text-align:center;margin-top:20px;">
      <div style="margin-top:15px;margin-bottom:15px;">
        <a href="#" id="trial_exam_attention" style="color:#b94a48;text-decoration:underline;" @click.prevent="showAttentionModal">
          <b>注意事項 ( 必ずお読みください )</b>
        </a>
      </div>
      <input 
        type="button" 
        class="btn btn-primary" 
        :class="{ 'btn-disabled': !selectedExamId }"
        id="exam_execute" 
        value="実施する" 
        style="width:100px;"
        :disabled="!selectedExamId"
        @click="startExam"
      >
      <div style="margin-top:15px;margin-bottom:15px;">
        <input type="checkbox" value="" id="tutorial" v-model="showTutorial" style="margin-right:10px;">開始前に操作説明を表示する
      </div>
    </div>
    <div style="text-align:right;"></div>
  </form>
</div>

<!-- Modal for Attention -->
<div v-if="showAttentionModalFlag" class="modal-backdrop" @click="closeAttentionModal"></div>
<div v-if="showAttentionModalFlag" class="modal" tabindex="-1" role="dialog">
  <div class="modal-header">
    <h3>注意事項</h3>
  </div>
  <div class="modal-body">
    
    <p><b>■操作上の注意</b></p>
    <p>・ブラウザの「戻る」「進む」ボタンは使用しないでください</p>
    <p>・途中で中断・再開することはできません</p>
    <p>・入力された解答内容は自動保存されません</p>
    <br>
    <p><b>■その他</b></p>
    <p>・実際の検定試験の合否を保証するものではありません</p>
    <p>・模擬試験プログラムで使用されるデータは、一定期間後に削除される場合があります</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" @click="closeAttentionModal">閉じる</button>
  </div>
</div>

</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useAuth } from '@/composables/useAuth';
import { useExamData } from '@/composables/useExamData';
import examData from '@/data/exam.json';

interface ExamContent {
  no: number;
  subNo: number;
  component: string;
}

interface ExamData {
  examId: number;
  name: string;
  contents: ExamContent[];
}

export default defineComponent({
  name: 'TopView',
  data() {
    return {
      showDropdown: false,
      showTutorial: false,
      showAttentionModalFlag: false,
      selectedExamId: null as number | null,
      examList: examData as ExamData[]
    };
  },
  computed: {
    visibleExamList(): ExamData[] {
      const { getAuthLevel } = useAuth();
      const all = this.examList.filter((exam: ExamData) => exam.examId >= 1 && exam.examId <= 5);
      if (getAuthLevel() === 'trial') {
        return all.filter((exam: ExamData) => exam.examId === 1);
      }
      return all;
    },
    selectedExam(): ExamData | undefined {
      return this.examList.find((exam: ExamData) => exam.examId === this.selectedExamId);
    },
    isSelectedExamTaken(): boolean {
      if (!this.selectedExamId) return false;
      try {
        return localStorage.getItem(`examTaken:${this.selectedExamId}`) === 'true';
      } catch (_e) {
        return false;
      }
    }
  },
  mounted() {
    // Add body class
    document.body.classList.add('body');
    
    // リロード時にhistory stateをクリア
    this.clearHistoryState();
  },
  beforeUnmount() {
    // Remove body class when leaving
    document.body.classList.remove('body');
  },
  methods: {
    clearHistoryState() {
      // composableの試験データをクリア
      const { clearExamData } = useExamData();
      clearExamData();
    },
    selectExam(examId: number) {
      this.selectedExamId = examId;
    },
    startExam() {
      if (!this.selectedExamId) {
        return;
      }
      if (this.showTutorial) {
        this.$router.push({
          path: '/operation-guide',
          query: { examId: String(this.selectedExamId) }
        });
      } else {
        this.$router.push({
          path: '/start',
          query: { examId: String(this.selectedExamId) }
        });
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    showAttentionModal() {
      this.showAttentionModalFlag = true;
    },
    closeAttentionModal() {
      this.showAttentionModalFlag = false;
    },
    handleLogout() {
      const { logout } = useAuth();
      logout();
      this.$router.push('/login');
    }
  }
});
</script>

<style scoped>
/* TopView専用スタイル */
.top-view {
  font-family: 'MS PGothic', Arial, 'Hiragino Kaku Gothic Pro', sans-serif;
  font-size: 13px;
  line-height: 1.4;
  color: #333333;
  background-color: #FFFFFF;
  word-break: break-all;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* すべての直接子要素に幅制限を適用 */
.top-view > * {
  max-width: 100%;
  box-sizing: border-box;
}

/* Header */
.top-view #header {
  background: #E1E1E1;
  background-image: -moz-linear-gradient(top, #F9F9F9, #E1E1E1);
  background-image: -webkit-linear-gradient(top, #F9F9F9, #E1E1E1);
  background-image: -o-linear-gradient(top, #F9F9F9, #E1E1E1);
  background-image: linear-gradient(to bottom, #F9F9F9, #E1E1E1);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr='#FFF9F9F9', endColorstr='#FFE1E1E1');
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}

.top-view #header .container {
  width: 100%;
  max-width: calc(1440px + 40px);
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.top-view .brand {
  text-decoration: none;
}

.top-view .brand img {
  height: 45px;
}

/* Navbar */
.top-view #navbar {
  margin-bottom: 20px;
  background: #222;
  background-image: -moz-linear-gradient(top, #333, #222);
  background-image: -webkit-linear-gradient(top, #333, #222);
  background-image: -o-linear-gradient(top, #333, #222);
  background-image: linear-gradient(to bottom, #333, #222);
  background-repeat: repeat-x;
  border: 1px solid #252525;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.067);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr='#FF333333', endColorstr='#FF222222');
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}

.top-view #navbar .container {
  width: 100%;
  max-width: calc(1440px + 40px);
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  box-sizing: border-box;
}

.top-view .navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.top-view .navbar-right {
  flex-shrink: 0;
}

.top-view #navbar #primary-nav {
  float: none;
  margin: 0;
  padding: 0;
  list-style: none;
}

.top-view #navbar #primary-nav > li {
  float: none;
  position: relative;
  display: inline-block;
}

.top-view #navbar #primary-nav > li > a {
  display: block;
  padding: 8px 10px 6px;
  font-size: 12px;
  font-weight: bold;
  color: #CCC;
  text-decoration: none;
}

.top-view #navbar #primary-nav > li > .top-view a:hover {
  color: #999;
}

.top-view .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.top-view .dropdown-menu li {
  display: block;
}

.top-view .dropdown-menu li a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 20px;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.top-view .dropdown-menu li .top-view a:hover {
  text-decoration: none;
  color: #fff;
  background-color: #0081c2;
  background-image: -moz-linear-gradient(top, #08c, #0077b3);
  background-image: -webkit-linear-gradient(top, #08c, #0077b3);
  background-image: -o-linear-gradient(top, #08c, #0077b3);
  background-image: linear-gradient(to bottom, #08c, #0077b3);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr='#FF0088CC', endColorstr='#FF0077B3');
}

.top-view .dropdown-menu .divider {
  height: 1px;
  margin: 9px 1px;
  overflow: hidden;
  background-color: #e5e5e5;
  border-bottom: 1px solid #fff;
}

/* Container */
.top-view .container {
  width: 100%;
  max-width: calc(1440px + 40px);
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* Table */
.top-view .table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: separate;
  border-spacing: 0;
  box-sizing: border-box;
}

.top-view .table-bordered {
  border: 1px solid #ddd;
  border-collapse: separate;
  border-left: 0;
  border-radius: 4px;
}

.top-view .table-bordered th,
.top-view .table-bordered td {
  border-left: 1px solid #ddd;
}

.top-view .table-bordered caption + thead tr:first-child th,
.top-view .table-bordered caption + tbody tr:first-child th,
.top-view .table-bordered caption + tbody tr:first-child td,
.top-view .table-bordered colgroup + thead tr:first-child th,
.top-view .table-bordered colgroup + tbody tr:first-child th,
.top-view .table-bordered colgroup + tbody tr:first-child td,
.top-view .table-bordered thead:first-child tr:first-child th,
.top-view .table-bordered tbody:first-child tr:first-child th,
.top-view .table-bordered tbody:first-child tr:first-child td {
  border-top: 0;
}

.top-view .table-bordered thead:first-child tr:first-child > th:first-child,
.top-view .table-bordered tbody:first-child tr:first-child > td:first-child,
.top-view .table-bordered tbody:first-child tr:first-child > th:first-child {
  border-top-left-radius: 4px;
}

.top-view .table-bordered thead:first-child tr:first-child > th:last-child,
.top-view .table-bordered tbody:first-child tr:first-child > td:last-child,
.top-view .table-bordered tbody:first-child tr:first-child > th:last-child {
  border-top-right-radius: 4px;
}

.top-view .table-bordered thead:last-child tr:last-child > th:first-child,
.top-view .table-bordered tbody:last-child tr:last-child > td:first-child,
.top-view .table-bordered tbody:last-child tr:last-child > th:first-child,
.top-view .table-bordered tfoot:last-child tr:last-child > td:first-child,
.top-view .table-bordered tfoot:last-child tr:last-child > th:first-child {
  border-bottom-left-radius: 4px;
}

.top-view .table-bordered thead:last-child tr:last-child > th:last-child,
.top-view .table-bordered tbody:last-child tr:last-child > td:last-child,
.top-view .table-bordered tbody:last-child tr:last-child > th:last-child,
.top-view .table-bordered tfoot:last-child tr:last-child > td:last-child,
.top-view .table-bordered tfoot:last-child tr:last-child > th:last-child {
  border-bottom-right-radius: 4px;
}

.top-view .table th,
.top-view .table td {
  padding: 8px;
  line-height: 20px;
  text-align: left;
  vertical-align: top;
  border-top: 1px solid #ddd;
  word-wrap: break-word;
  box-sizing: border-box;
}

.top-view .table th {
  font-weight: bold;
}

.top-view .contents-info-tbl-colhead {
  width: 20%;
  background-color: #f0f0f0;
}

/* Buttons */
.top-view .btn {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
  vertical-align: middle;
  cursor: pointer;
  background-color: #f5f5f5;
  background-image: -moz-linear-gradient(top, #fff, #e6e6e6);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fff), to(#e6e6e6));
  background-image: -webkit-linear-gradient(top, #fff, #e6e6e6);
  background-image: -o-linear-gradient(top, #fff, #e6e6e6);
  background-image: linear-gradient(to bottom, #fff, #e6e6e6);
  background-repeat: repeat-x;
  border: 1px solid #ccc;
  border-color: #e6e6e6 #e6e6e6 #bfbfbf;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  border-bottom-color: #b3b3b3;
  border-radius: 4px;
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr='#FFFFFFFF', endColorstr='#FFE6E6E6');
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}

.top-view .btn:hover,
.top-view .btn:focus,
.top-view .btn:active,
.top-view .btn.active,
.top-view .btn.disabled,
.top-view .btn[disabled] {
  color: #333;
  background-color: #e6e6e6;
}

.top-view .btn:active,
.top-view .btn.active {
  background-color: #ccc \9;
}

.top-view .btn-primary {
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  background-color: #006dcc;
  background-image: -moz-linear-gradient(top, #08c, #0044cc);
  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#08c), to(#0044cc));
  background-image: -webkit-linear-gradient(top, #08c, #0044cc);
  background-image: -o-linear-gradient(top, #08c, #0044cc);
  background-image: linear-gradient(to bottom, #08c, #0044cc);
  background-repeat: repeat-x;
  border-color: #0044cc #0044cc #002a80;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr='#FF0088CC', endColorstr='#FF0044CC');
}

.top-view .btn-primary:hover,
.top-view .btn-primary:focus,
.top-view .btn-primary:active,
.top-view .btn-primary.active,
.top-view .btn-primary.disabled,
.top-view .btn-primary[disabled] {
  color: #fff;
  background-color: #0044cc;
}

.top-view .btn-primary:active,
.top-view .btn-primary.active {
  background-color: #003bb3 \9;
}

/* Disabled visual state */
.top-view .btn-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(40%);
}

/* Labels */
.top-view .text-label {
  display: inline;
  padding: 2px 4px;
  font-size: 11.844px;
  font-weight: bold;
  line-height: 14px;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #999;
}

.top-view .label-success {
  background-color: #468847;
}

.top-view .label-danger {
  background-color: #b94a48;
}

/* Info Field */
.top-view .info-field {
  border: 1px solid #A5DDFC;
  padding: 10px 15px;
  background-color: #F4FAFE;
  clear: both;
  font-size: 12px;
  margin-bottom: 20px;
}

/* Footer */
.top-view #footer {
  border-top: 1px solid #e5e5e5;
  margin-top: 45px;
  padding: 35px 0 36px;
  background-color: #f5f5f5;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}

.top-view #footer .container {
  width: 100%;
  max-width: calc(1440px + 40px);
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.top-view .copy {
  color: #999;
  text-align: center;
  font-size: 11px;
}

/* Modal Styles */
.top-view .modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000000;
  opacity: 0.8;
}

.top-view .modal {
  position: fixed;
  top: 10%;
  left: 50%;
  z-index: 1050;
  width: 560px;
  margin-left: -280px;
  background-color: #ffffff;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  outline: none;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
}

.top-view .modal-header {
  padding: 9px 15px;
  border-bottom: 1px solid #eee;
}

.top-view .modal-header h3 {
  margin: 0;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

.top-view .modal-body {
  position: relative;
  max-height: 400px;
  padding: 15px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.5;
}

.top-view .modal-body p {
  margin: 0.5em 0;
}

.top-view .modal-footer {
  padding: 14px 15px 15px;
  margin-bottom: 0;
  text-align: right;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-radius: 0 0 6px 6px;
  box-shadow: inset 0 1px 0 #ffffff;
}

/* Links */
.top-view a {
  color: #0088cc;
  text-decoration: none;
}

.top-view a:hover {
  color: #005580;
  text-decoration: underline;
}

/* Exam Selection Section */
.exam-selection-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.section-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.exam-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.exam-item {
  padding: 12px 15px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.exam-item:hover {
  background-color: #f0f8ff;
  border-color: #0088cc;
}

.exam-item-active {
  background-color: #e6f3ff;
  border-color: #0088cc;
  border-width: 2px;
}

.exam-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.exam-name {
  font-size: 14px;
  color: #333;
}

.check-icon {
  color: #0088cc;
  font-size: 16px;
}
</style>
